export default "__VITE_ASSET__Bm8t13y0__"